<template>
  <a-modal
    v-model="showModal"
    :title="selectedCondition ? 'Edit description' : 'Add description'"
    :footer="null"
    width="600px"
    :destroyOnClose="true"
    class="condition-description-modal"
  >
    <a-form-model class="" ref="conditionDescForm" :model="form">
      <Readonly
        :show="isOnlyView"
        title="Name"
        :value="form.name"
        :required="true"
        class="mb-4"
      >
        <a-form-model-item
          label="Name"
          key="name"
          prop="name"
          :colon="false"
          :rules="[
            { required: true, message: 'Name is required', trigger: ['change'] },
          ]"
        >
          <a-input
            v-model="form.name"
            ref="input-name"
            placeholder="Name"
            size="large"
          />
        </a-form-model-item>
      </Readonly>
      <a-row class="footer-viewscreen footer" :class="{'justify-content-end' : isOnlyView}">
        <div v-if="!isOnlyView" class="w-fit d-flex justify-content-start">
          <a-popconfirm
            v-if="isEdit"
            placement="top"
            title="Are you sure you want to delete this description?"
            okText="Delete"
            okType="danger"
            @confirm="deleteDesc"
          >
            <a-button type="danger">
              <a-icon type="delete" theme="filled" />
            </a-button>
          </a-popconfirm>
        </div>
        <div class="d-flex justify-content-end" :class="{'w-full' : isOnlyView}">
          <a-button
            @click="closeModal"
          >
            Cancel
          </a-button>
          <a-button
            v-if="!isOnlyView"
            type="primary"
            class="ml-2"
            @click="onSubmit"
          >
            {{ selectedCondition ? 'Save' : 'Add' }}
          </a-button>
        </div>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import Readonly from '@/components/custom/readonlyMode/readonly.vue'
import { waitForRef } from '@/composables/useWaitForRef.js'
import { subscribe, unsubscribe } from '@/composables/keydownEvent.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedCondition: {
      type: Object,
      default: null,
    },
    isOnlyView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Readonly,
  },
  data: () => ({
    showModal: false,
    form: {
      name: '',
    },
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    isEdit() {
      return !!this.selectedCondition
    },
  },
  methods: {
    async focusInput() {
      if (!this.isOnlyView) {
        await waitForRef('input-name', this)
          .then((inputRef) => {
            inputRef.focus()
          })
          .catch((err) => {
            console.warn('Не удалось получить $refs.input:', err)
          })
      }
    },
    templateDataFilling() {
      this.form.name = this.selectedCondition.name
    },
    onSubmit() {
      this.$refs.conditionDescForm.validate(async (valid) => {
        if (!valid) {
          this.$notification.error({
            message: 'Please fill in all required fields',
          })
          return false
        }
        if (this.isEdit) {
          this.update()
          return
        }
        this.create()
      })
    },
    create() {
      this.$emit('create', this.form.name)
      this.closeModal()
    },
    async update() {
      this.$emit('update', { ...this.selectedCondition, name: this.form.name })
      this.closeModal()
    },
    deleteDesc() {
      this.$emit('delete', this.selectedCondition)
      this.closeModal()
    },
    clearForm() {
      this.form = {
        name: '',
      }
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.clearForm()
      }, 500)
    },
  },
  async mounted() {
    this.focusInput()
    subscribe(this.onSubmit)
    if (!this.isEdit) {
      return
    }
    this.templateDataFilling()
  },
  beforeDestroy() {
    unsubscribe()
  },
}
</script>

<style lang="scss">
.condition-description-modal {
  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
